import { Skeleton, Text } from '@hopskipdrive/react-components';
import { colorTokens } from '@rideiq/shared/components/variables';

import { BannerContainer } from './AccountNameBar.styles';

interface AccountNameBarProps {
  name?: string;
  loading?: boolean;
}

export const AccountNameBar: React.FC<AccountNameBarProps> = ({ name, loading }) => {
  return (
    <BannerContainer data-testid="account-name-bar">
      {loading || !name ? (
        <Skeleton variant="text" width={120} animation="wave" />
      ) : (
        <Text variant="labelM" style={{ color: colorTokens.text.medium }}>
          {name}
        </Text>
      )}
    </BannerContainer>
  );
};
